import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n";
import { waLink } from "@/config";
import { trackWhatsAppClick } from "@/analytics";

const IMG =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_huitzil-tours/artifacts/qh9kt054_CC1CD315-C48A-40A7-A5BE-B1854B4DAE0F.PNG";

export default function PreFooterCTA() {
  const { t, lang } = useLang();
  const waMsg =
    lang === "es"
      ? "Hola, quiero planear mi próxima experiencia con Huitzil-Coatl Travels."
      : "Hello, I want to plan my next experience with Huitzil-Coatl Travels.";

  return (
    <section data-testid="prefooter-cta" className="relative overflow-hidden">
      <img
        src={IMG}
        alt={lang === "es" ? "Atardecer con globos aerostáticos sobre el valle" : "Sunset with hot air balloons over the valley"}
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-[#050908]/65" />
      <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-12 py-28 md:py-44 text-center">
        <h2 className="font-serif-hc font-light text-4xl sm:text-5xl md:text-7xl leading-[1.02] text-[#F5F2EA] max-w-4xl mx-auto">
          {t("prefooter.title")}
        </h2>
        <p className="mt-6 text-lg md:text-xl text-[#F5F2EA]/80 font-light">{t("prefooter.body")}</p>
        <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/tours" data-testid="prefooter-cta-tours" className="hc-btn-primary">
            {t("prefooter.cta_tours")}
          </Link>
          <a
            href={waLink(waMsg)}
            target="_blank"
            rel="noreferrer"
            data-testid="prefooter-cta-expert"
            onClick={() => trackWhatsAppClick("prefooter")}
            className="hc-btn-secondary"
          >
            {t("prefooter.cta_expert")}
          </a>
        </div>
      </div>
    </section>
  );
}
